import type { SuggestionCategory } from "../types/suggestions.types";

/**
 * Category labels (French)
 */
export const SUGGESTION_CATEGORY_LABELS: Record<SuggestionCategory, string> = {
  improvement: "Amélioration",
  new_feature: "Nouvelle fonctionnalité",
} as const;

/**
 * Subcategory options per category
 */
export const SUGGESTION_SUBCATEGORIES: Record<
  SuggestionCategory,
  Array<{ value: string, label: string }>
> = {
  improvement: [
    { value: "visual_improvement", label: "Amélioration visuelle" },
    { value: "ux_improvement", label: "Amélioration d'expérience utilisateur" },
    { value: "feature_misunderstanding", label: "Incompréhension d'utilisation de fonctionnalités" },
  ],
  new_feature: [
    { value: "feature_extension", label: "Extension d'une fonctionnalité existante" },
    { value: "entirely_new", label: "Nouvelle fonctionnalité" },
  ],
} as const;

/**
 * Toast messages
 */
export const SUGGESTION_STATUSES = [
  { value: "pending", label: "En attente", variant: "yellow" },
  { value: "reviewed", label: "En cours d'analyse", variant: "blue" },
  { value: "planned", label: "Planifiée", variant: "purple" },
  { value: "completed", label: "Réalisée", variant: "green" },
  { value: "rejected", label: "Rejetée", variant: "red" },
] as const;

export const SUGGESTIONS_MESSAGES = {
  CREATE_SUCCESS: "Suggestion envoyée avec succès",
  CREATE_ERROR: "Erreur lors de l'envoi de la suggestion",
  UPDATE_SUCCESS: "Suggestion modifiée avec succès",
  UPDATE_ERROR: "Erreur lors de la modification de la suggestion",
} as const;
